import styled from "styled-components";
import {achievements, trophyImages} from "../../../content-options/trophy";
import {FC} from "react";

interface Props {
    achievement: string;
    quantity: number;
}

const VgcDor: FC<Props> = ({ achievement, quantity }) => {

    const image =  trophyImages[achievement as keyof typeof trophyImages]

    return (
        <>
            <Container>
                <Img src={image} />
                <Quantity>{quantity}</Quantity>

            </Container>
    </>
  );
};

export default VgcDor;

const Container = styled.div`
  height: 100%;
  aspect-ratio: 1/1;

  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;
const Img = styled.img`
  width: 100%;
  max-width: 100%;
  aspect-ratio: 1/1;
`;
const Quantity = styled.div`
  position: absolute;
  height: 33%;
  width: 33%;
  border: solid black 3px;
  right: -8%;
  bottom: 3%;
  border-radius: 50%;
  background-color: white;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: x-large;
  /* font-size: clamp(0.8rem, 1vw + 0.8rem, 1.3rem); */
`;
